module.exports = __webpack_public_path__ + "assets/images/Agenda/signup.b5c4c9683a1357fdb778a40c5cb0422e.png";